// Third-party
import 'details-element-polyfill'

// Molecules
import './components/molecules/gallery/gallery'
import './components/molecules/navigation/main/main'
import './components/molecules/navigation/strip/strip'
import './components/molecules/sidebar/sidebar'
import './components/molecules/dropdown/dropdown'
import { Jobs } from './components/molecules/jobs/jobs.js'
import { Toggle } from './components/atoms/toggle/toggle.js'
import { Accordion } from './components/molecules/accordion/accordion.ts'

document.addEventListener('DOMContentLoaded', () => {
  const jobElements = document.querySelectorAll('[data-component="jobs"]')
  jobElements.forEach(element => {
    new Jobs(element) // eslint-disable-line no-new
  })

  const toggles = document.querySelectorAll('[data-component="toggle"]')
  toggles.forEach(toggle => {
    new Toggle(toggle) // eslint-disable-line no-new
  })

  const accordionElements = document.querySelectorAll('[data-component="accordion"]')
  accordionElements.forEach(element => {
    new Accordion(element) // eslint-disable-line no-new
  })
})
